import * as React from 'react';
import styles from './filter-error.scss';

export interface FilterErrorProps {
  label: string;
  message: string;
}

export const FilterError = (props: FilterErrorProps) => {
  return <div className={styles.uiFilterError}>
    <b>{props.label}</b>
    <p>{props.message}</p>
  </div>;
};
